export const columns = [
  {
    name: "Added At",
    selector: "attributes.format_created_at",
    sortable: true,
    sortFunction: (a, b) =>
      a.attributes.created_at_int - b.attributes.created_at_int,
  },
  {
    name: "Status",
    selector: "attributes.status",
    sortable: true,
  },
  {
    name: "Type Credit",
    selector: "attributes.type_credit",
    sortable: true,
  },
  {
    name: "Source",
    selector: "attributes.source",
    sortable: true,
  },    
  {
    name: "Valid From",
    selector: "attributes.format_valid_from",
    sortable: true,
    sortFunction: (a, b) =>
      a.attributes.valid_from_int - b.attributes.valid_from_int,
  },
  {
    name: "Valid To",
    selector: "attributes.format_valid_to",
    sortable: true,
    sortFunction: (a, b) =>
      a.attributes.valid_to_int - b.attributes.valid_to_int,
  },
];
